//import Head from 'next/head'
import React, { useEffect } from 'react'
import '../styles/globals.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import SSRProvider from 'react-bootstrap/SSRProvider'
import Header from '../components/Header/'
import Footer from '../components/Footer'
import { Provider } from 'react-redux'
import store from '../store'
import Head from 'next/head'
import Script from 'next/script'
import { useRouter } from 'next/router'
import MaintenanceScreen from '../screens/MaintenanceScreen'

function MyApp({ Component, pageProps }) {
  const router = useRouter()
  const currentPath = router.pathname
  return (
    <>
      <Head>
        <meta name="google-site-verification" content="-6yP9KvmeOVo_3B7UOQMXLm7v6l1tC6-nO2RImeSjoA" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <Script id="facebook-pixel">
        {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '3163539570576161');
        fbq('track', 'PageView');
      `}
      </Script>

      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=3163539570576161&ev=PageView&noscript=1"
        />
      </noscript>

      <Script type="text/javascript">
        {`window.pipedriveLeadboosterConfig = {
    base: 'leadbooster-chat.pipedrive.com',
    companyId: 7478333,
    playbookUuid: '51026293-20ee-4640-86de-03c350df45f6',
    version: 2
};
(function() {
    var w = window;
    if (w.LeadBooster) {
        console.warn('LeadBooster already exists');
    } else {
        w.LeadBooster = {
            q: [],
            on: function(n, h) {
                this.q.push({
                    t: 'o',
                    n: n,
                    h: h
                });
            },
            trigger: function(n) {
                this.q.push({
                    t: 't',
                    n: n
                });
            },
        };
    }
})();`}
      </Script>
      {currentPath != '/google-form' &&
        currentPath != '/google-ivy-league' &&
        currentPath != '/campaigns/ug-advising' && (
          <Script src="https://leadbooster-chat.pipedrive.com/assets/loader.js" async></Script>
        )}

      <Script type="text/javascript">
        {`
        _linkedin_partner_id = "925971";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        `}
      </Script>
      {/* <Script type="text/javascript">
        {`(function(l) {
        if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
        window.lintrk.q=[]}
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);})(window.lintrk);
        `}
      </Script> */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          alt=""
          src="https://px.ads.linkedin.com/collect/?pid=925971&fmt=gif"
        />
      </noscript>

      <Script async src="https://www.googletagmanager.com/gtag/js?id=UA-140978374-1"></Script>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'UA-140978374-1');
            `,
        }}
      />
      <Script async src="https://www.googletagmanager.com/gtag/js?id=AW-461896372"></Script>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-461896372');
            `,
        }}
      />
      <Script>
        {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '708813799995238');
        fbq('track', 'PageView');
        `}
      </Script>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=708813799995238&ev=PageView&noscript=1"
        />
      </noscript>
      <Script>
        {`
        (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"137036034"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");
      `}
      </Script>
      <Script type="text/javascript">
        {`
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "4i2ajo92yc");
      `}
      </Script>
      <Script>
        {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-WN2GFQ4');
    `}
      </Script>
      <Script>
        {`var EhAPI = EhAPI || {}; EhAPI.after_load = function(){ EhAPI.set_account('c799615vsbmqaujdmeqi53sgeb', 'collegepass'); 
EhAPI.execute('rules');};(function(d,s,f) { var sc=document.createElement(s);sc.type='text/javascript';
 sc.async=true;sc.src=f;var m=document.getElementsByTagName(s)[0]; m.parentNode.insertBefore(sc,m); })
 (document, 'script', '//d2p078bqz5urf7.cloudfront.net/jsapi/ehform.js');
`}
      </Script>

      <Script>
        {`!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '3163539570576161');
          fbq('track', 'PageView');`}
      </Script>

      <Script type="application/ld+json">
        {`{"@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [{
            "@type": "Question",
            "name": "What is CollegePass?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "CollegePass is an international college admissions company serving students from diverse locations, including the US, India, UK, Singapore, and over 10 other countries. CollegePass has teamed up with students from more than 1200 schools globally, and they are attending The Ivy League, University of Cambridge, Johns Hopkins, Georgia Tech, Carnegie Mellon, NUS, Imperial College London, and more."
            }
          },{
            "@type": "Question",
            "name": "How does CollegePass help students and parents?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "CollegePass offers personalized services, including one-on-one college admissions advising, profile building, essay and Statement of Purpose (SOP) editing, summer planning, extracurricular strategy development, research mentoring, scholarship/financial aid strategy development, and IB/IGCSE/SAT/AP tutoring."
            }
          },{
            "@type": "Question",
            "name": "Does CollegePass provide guaranteed admissions to colleges?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "100% of CollegePass students received offers! Notably, each student secured at least 3 admission offers, underscoring the effectiveness of our tailored approach in navigating the complex admissions landscape."
            }
          }]}`}
      </Script>

      <Script TYPE="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "EducationalOrganization",
          "name": "CollegePass",
          "url": "https://www.collegepass.org/",
          "logo": "https://www.collegepass.org/_next/image?url=%2Flogo%2Fcp_text_logo.png&w=384&q=75",
          "sameAs": [
            "https://www.facebook.com/CollegePassPremiere",
            "https://www.instagram.com/_collegepass/",
            "https://www.youtube.com/@CollegePass",
            "https://www.linkedin.com/company/collegepass/",
            "https://www.collegepass.org/"
          ]
        }
        `}
      </Script>

      <Script>
        {`window['_fs_host'] = 'fullstory.com'; window['_fs_script'] = 'edge.fullstory.com/s/fs.js'; window['_fs_org'] = 'o-21Y3RK-na1'; window['_fs_namespace'] = 'FS'; !function(m,n,e,t,l,o,g,y){var s,f,a=function(h){ return!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].'),!1)}(e) ;function p(b){var h,d=[];function j(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))} d&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function r(b){return function(d){h||(h=[b,d],j())}}return b(r(0),r(1)),{ then:function(b,h){return p((function(r,i){d.push([b,h,r,i]),j()}))}}}a&&(g=m[e]=function(){var b=function(b,d,j,r){function i(i,c){ h(b,d,j,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,""),"function"==typeof Promise?new Promise(i):p(i)):h(b,d,j,c,c,r)} ;function h(h,d,j,r,i,c){return b._api?b._api(h,d,j,r,i,c):(b.q&&b.q.push([h,d,j,r,i,c]),null)}return b.q=[],b}(),y=function(b){function h(h){ "function"==typeof h[4]&&h[4](new Error(b))}var d=g.q;if(d){for(var j=0;j<d.length;j++)h(d[j]);d.length=0,d.push=h}},function(){ (o=n.createElement(t)).async=!0,o.crossOrigin="anonymous",o.src="https://"+l,o.onerror=function(){y("Error loading "+l)} ;var b=n.getElementsByTagName(t)[0];b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}(),function(){function b(){} function h(b,h,d){g(b,h,d,1)}function d(b,d,j){h("setProperties",{type:b,properties:d},j)}function j(b,h){d("user",b,h)}function r(b,h,d){j({ uid:b},d),h&&j(h,d)}g.identify=r,g.setUserVars=j,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,j){h("trackEvent",{ name:b,properties:d},j)},g.anonymize=function(){r(!1)},g.shutdown=function(){h("shutdown")},g.restart=function(){h("restart")}, g.log=function(b,d){h("log",{level:b,msg:d})},g.consent=function(b){h("setIdentity",{consent:!arguments.length||b})}}(),s="fetch", f="XMLHttpRequest",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v="2.0.0") }(window,document,window._fs_namespace,"script",window._fs_script);`}
      </Script>

      <Script type="text/javascript">
        {`window.smartlook||(function(d) {
    var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
    var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
    c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
    })(document);
    smartlook('init', 'c79e599c74bfba1c3d930280a328fafea5c2502b', { region: 'eu' });`}
      </Script>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=3163539570576161&ev=PageView&noscript=1"
        />
      </noscript>
      {/* <!-- Start of HubSpot Embed Code --> */}
      <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/9462818.js"></script>
      {/* <!-- End of HubSpot Embed Code --> */}

      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-WN2GFQ4"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>

      <Provider store={store}>
        <SSRProvider>
          <Header />
          <Component {...pageProps} />
          <Footer />
          {/* <MaintenanceScreen /> */}
        </SSRProvider>
      </Provider>
    </>
  )
}

export default MyApp
